/* eslint-disable react-hooks/rules-of-hooks */
"use client";

import { CardProps, EntretienCreation } from "@/components/templates";
import styles from "./styles.module.scss";
import { entretienData, steps } from "./data";
import uniqid from "uniqid";
import { MyButton, MyH2 } from "@/components/atoms";

const entretiens: CardProps[] = entretienData.map(
  ({ image, textsCard, title, slug }, id) => ({
    id,
    image,
    alt: title,
    slug,
    children: ({ id }: { id?: string }) => {
      return (
        <div className={styles.card}>
          <MyH2>{title}</MyH2>
          <div className={styles.paragraphs}>
            {(textsCard || []).map((el: any) => (
              <p key={uniqid()} dangerouslySetInnerHTML={{ __html: el }}></p>
            ))}
          </div>
          <div className={styles.btn_container}>
            <MyButton id={id} to={`/entretien/${slug}`} label="Découvrir" />
          </div>
        </div>
      );
    },
  })
);

const breadCrumbs = [
  {
    url: "/",
    label: "Accueil",
  },
  {
    url: "/entretien",
    label: "Entretien",
  },
];

export const Entretien = () => {
  return (
    <EntretienCreation
      breadCrumbs={breadCrumbs}
      cards={entretiens}
      steps={steps}
      title="Entretien"
      text={
        /* html */ `
        <p>Étape essentielle dans la vie d&apos;un jardin, l&apos;entretien permet de préserver, <br class="hidden lg:inline-block" /> soigner et, si besoin, maîtriser votre écrin de verdure.</p>`
      }
      root="entretien"
    />
  );
};
